import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import sidebar from "./modules/sidebar";
import preloader from "./modules/preloader";
import user from "./modules/user";
import donamakers from "./modules/donamakers";
import clients from "./modules/clients";
import professionals from "./modules/professionals";
import cities from "./modules/cities";
import districts from "./modules/districts";
import countries from "./modules/countries";
import states from "./modules/states";
import orders from "./modules/orders";
import ordersList from "./modules/orders/list";
import coupons from "./modules/coupons";
import newOrder from "./modules/newOrder";
import newSubscription from "./modules/newSubscription";
import newPurchase from "./modules/newPurchase";
import addresses from "./modules/addresses";
import bankAccounts from "./modules/bankAccounts";
import notifications from "./modules/notifications";
import wallets from "./modules/wallets";
import transfers from "./modules/transfers";
import transfersList from "./modules/transfers/list";
import orderRebooking from "./modules/orderRebooking";
import physicals from "./modules/physicals";
import legals from "./modules/legals";
import snackbar from "./modules/snackbar";
import account from "./modules/account";
import newAddress from "./modules/newAddress";
import documents from "./modules/documents";
import newDocument from "./modules/newDocument";
import professionalRegisterFlow from "./modules/professionalRegisterFlow";
import professionalTrainingFlow from "./modules/professionalTrainingFlow";
import sendNotifications from "./modules/notifications/send";
import professionalStores from "./modules/professionals/index";
import phones from "./modules/account/phones";

export default new Vuex.Store({
  modules: {
    sidebar,
    preloader,
    user,
    donamakers,
    clients,
    professionals,
    cities,
    districts,
    countries,
    states,
    orders,
    ordersList,
    coupons,
    newOrder,
    newSubscription,
    newPurchase,
    addresses,
    bankAccounts,
    notifications,
    wallets,
    transfers,
    transfersList,
    orderRebooking,
    physicals,
    legals,
    snackbar,
    account,
    newAddress,
    sendNotifications,
    documents,
    newDocument,
    professionalRegisterFlow,
    ...professionalStores,
    professionalTrainingFlow,
    phones
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js